<template>
  <div class="body_">
    <div class="body_main">
      <div class="bm_detailPage">
        <div class="mbd_left">
          <!-- <img class="mbd_left_bag" :src="message.showImage" /> -->
          <img class="mbd_left_bottom" :src="list.showImage" />
          <img class="body_mlti_bottom" :src="runningStatus == false
            ? require('@/assets/music_b_BF.png')
            : require('@/assets/music_b_BF_f.png')
            " @click.stop="handleCallback1(list)" />
        </div>
        <div class="mbd_right">
          <div class="bmm_top">
            <div class="bmmt_title">{{ list.title }}</div>
            <div class="bmmt_t_list">
              <span>时长：{{ list.playTime }}</span>
              <span>节拍：{{ list.startBpm }}</span>
              <span>音频格式：{{ list.fileExt }}</span>
              <div></div>
              <span>文件大小：{{ list.fileSize }}</span>
              <span>采样率：{{ list.samplingRate }}</span>
              <span>采样精度：—</span>
              <div></div>
              <span>素材ID：{{ list.code }}</span>
            </div>
            <div class="bmmt_t_click">
              <div @click="click_sc">
                <img :src="list.isCollect == 0
                  ? require('@/assets/music_b_SC.png')
                  : require('@/assets/music_b_SC_OK.png')
                  " />
                <span>收藏</span>
              </div>
              <div @click="click_fzlj" style="cursor: pointer">
                <img src="@/assets/scxx_fx.png" />
                <span>复制链接</span>
              </div>
              <div>
                <div class="br_main" @click="ShadowComposerHomepage(list)">
                  <img style="height: 0.3rem; width: 0.3rem; border-radius: 50%" :src="list.avatar ? list.avatar : require('@/assets/logo.png')
                    " />
                  <span style="margin-right: 0.2rem">{{
                    list.createUserName
                  }}</span>
                  <img v-if="userList.realStatus == 2" src="@/assets/Frame1.png" title="实名认证"
                    @click.stop="CertificationCenter" />

                  <img v-if="userList.enterpriseStatus == 2" src="@/assets/Frame2.png" title="企业认证"
                    @click.stop="CertificationCenter" />
                  <img v-if="userList.unionStatus == 2" src="@/assets/Frame3.png" title="联盟认证"
                    @click.stop="CertificationCenter" />
                </div>
                <view class="wVC_list_l_T_B_rz" v-if="userList.professionalStatus == 2">
                  <img src="../../assets/bvlv_blue.png" />
                  标识山西认证{{ userList.profess }}
                </view>
              </div>

              <div style="margin-left: auto" @click="module_informOverNo1" v-if="!is__">
                <img src="../../assets/scxx_jb.png" />
                <span>举报</span>
              </div>
            </div>
            <div class="body_ml_bottom">
              <span v-for="index in list.typeNames" @click="pushpush(index)" :key="index">{{ index }}</span>
            </div>
            <div class="bmmt_t_type">
              <!-- <div v-for="(index) in message.typeNames" :key="index">{{index}}</div> -->
            </div>
          </div>
          <div class="bmm_bottom">
            <div class="bmmb_list" v-if="list.selfPrice">
              <div v-for="(index, i) in clickList" :class="index.checked == true ? 'bmmb_listT' : 'bmmb_listF'"
                @click="BR_TabClick(index, i)" :key="index">
                {{ index.title }}
              </div>
            </div>
            <div class="bmmb_list" v-else>
              <div v-for="(index, i) in clickList1" :class="index.checked == true ? 'bmmb_listT' : 'bmmb_listF'"
                @click="BR_TabClick(index, i)" :key="index">
                {{ index.title }}
              </div>
            </div>
            <div class="bmmb_gn">
              <div>
                <div class="bmmbg_jg1">
                  <span v-if="selectPrice == 0">￥{{ list.selfPrice ? (list.selfPrice / 1).toFixed(2) : 0 }}</span>
                  <span v-if="selectPrice == 1">￥{{ list.enterPrice ? (list.enterPrice / 1).toFixed(2) : 0 }}</span>
                  <span v-if="selectPrice == 2">￥{{ list.enterPlusPrice ? (list.enterPlusPrice / 1).toFixed(2) : 0
                  }}</span>
                </div>
                <!-- <div class="bmmbg_jg2">会员专享价 ￥40.00</div> -->
              </div>
              <div>
                <div class="bmmbg_click1" @click="downloadClick">立即下载</div>
                <div @click="shoppingTrolley" class="bmmbg_click2" v-if="selectPrice == 0 && list.selfPrice != 0">
                  加入购物车
                </div>
                <div @click="shoppingTrolley" class="bmmbg_click2" v-if="selectPrice == 1 && list.enterPrice != 0">
                  加入购物车
                </div>
                <div @click="shoppingTrolley" class="bmmbg_click2" v-if="selectPrice == 2 && list.enterPlusPrice != 0">
                  加入购物车
                </div>
              </div>
            </div>
            <!-- <div class="bmmb_mf">
              <span style="margin-right: 0.4rem">升级会员获取免费下载次数</span>
              <span>></span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="bm_musicList">
        <div>购买此素材的人还购买了</div>
        <img class="zwsj" v-if="musicLikenessList.length == 0" src="../../assets/zt_zanwushuju.png" />
        <el-row :gutter="20" v-else>
          <el-col :span="12" v-for="index in musicLikenessList" :key="index">
            <moduleProvideMaterialMusic :collectIds="collectIds" :message="index" class="SL_offerMaterialListdiv"
              @callback="handleCallback" ref="moduleProvideMaterialMusicRef">
            </moduleProvideMaterialMusic>
          </el-col>
        </el-row>
      </div>
    </div>
    <view v-if="module_informChecked" class="module_inform">
      <view class="module_inform_body">
        <view class="module_share_body_top">
          <view>选择举报理由</view>
          <img @click="module_informOverNo" src="@/assets/module_share_open.png" />
        </view>
        <view>
          <view>
            <el-radio-group v-model="type">
              <el-row :gutter="20">
                <el-col :span="8"><el-radio label="1">违法违禁</el-radio></el-col>
                <el-col :span="8"><el-radio label="2">政治敏感</el-radio></el-col>
                <el-col :span="8"><el-radio label="3">色情低俗</el-radio></el-col>
                <el-col :span="8"><el-radio label="4">人身攻击</el-radio></el-col>
                <el-col :span="8"><el-radio label="5">垃圾广告</el-radio></el-col>
                <el-col :span="8"><el-radio label="6">刷屏</el-radio></el-col>
                <el-col :span="8"><el-radio label="7">其他问题</el-radio></el-col>
              </el-row>
            </el-radio-group>
          </view>
          <textarea placeholder="请输入举报内容" maxLength="100" v-model="reason" class="module_share_textarea"></textarea>
          <view class="module_share_button">
            <button class="module_share_button_Y" @click="handleReport">
              确定
            </button>
            <button class="module_share_button_N" @click="module_informOverNo">
              取消
            </button>
          </view>
        </view>
      </view>
    </view>
    <!-- <div class="yinyue">
      <ShadowMaterialyinyue
        v-show="isChildVisible"
        ref="ShadowMaterialyinyueRef"
        :mp3url="bovalue"
        :MusicOff="MusicOff"
      ></ShadowMaterialyinyue>
    </div> -->
    <wavesurfer ref="ShadowMaterialyinyueRef" v-model="isChildVisible" v-bind="bovalue" @stop="MusicOff" @play="MusicOn"
      @download_="downloadClick"></wavesurfer>
  </div>
</template>
<script setup>
import { ref, onBeforeUnmount, nextTick } from "vue";
import { useRouter } from "vue-router";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage, ElTable } from "element-plus";
import wavesurfer from '@/components/Wavesurfer/index.vue'
// import ShadowMaterialyinyue from "./ShadowMaterialyinyue.vue";
document.title = "标识山西-找素材-音乐素材";
import moduleProvideMaterialMusic from "../../components/moduleProvideMaterialMusic.vue";
const router = useRouter();
let id = router.currentRoute.value.query.id;
const newData = defineProps({
  id: {},
});

const tabListType = ref("SELF");
// 复制链接
const click_fzlj = function () {
  navigator.clipboard.writeText(window.location.href).then(() => {
    ElMessage({
      showClose: true,
      message: "复制成功",
      type: "success",
    });
  });
};

const clickList = ref([
  {
    title: "个人授权",
    authType: "SELF",
    checked: true,
  },
  {
    title: "企业授权",
    authType: "ENTERPRISE",
    checked: false,
  },
  {
    title: "企业Plus",
    authType: "UNION",
    checked: false,
  },
]);
const clickList1 = ref([
  {
    title: "个人授权",
    authType: "SELF",
    checked: true,
  },
]);
const module_informChecked = ref(false);
const reason = ref("");
const type = ref("");
const selectPrice = ref(0);
const MusicOff = (id) => {
  runningStatus.value = false
  moduleProvideMaterialMusicRef.value.forEach((e) => {
    if (id == e.newData.message.id) {
      e.sendValue2();
    }
  });
};
const MusicOn = (id) => {
  if (list.value.id == id) {
    runningStatus.value = true
  }
  moduleProvideMaterialMusicRef.value.forEach((e) => {
    if (id == e.newData.message.id) {
      e.sendValue3();
    }
  });
}
const BR_TabClick = function (index, arrI) {
  selectPrice.value = arrI;
  for (let i = 0; i < clickList.value.length; i++) {
    if (clickList.value[i] == index) {
      clickList.value[i].checked = true;
      tabListType.value = clickList.value[i].authType;
    } else {
      clickList.value[i].checked = false;
    }
  }
};
const module_informOverNo = () => {
  module_informChecked.value = false;
  type.value = "";
  reason.value = "";
};
const module_informOverNo1 = () => {
  module_informChecked.value = true;
};
const handleReport = function () {
  if (!type.value) {
    ElMessage.warning("请选择举报类型");
    return;
  }
  Axios(
    "POST",
    "/fodder/report",
    { materialId: id, remark: type.value },
    null,
    false,
    function (res) {
      ElMessage.success("举报成功");
      module_informChecked.value = false;
      // emit("openClickOverOpen");
    }
  );
};
// 音乐播放
const isChildVisible = ref(false);
const bovalue = ref("");
const yinyuelist = ref(null);
//播放状态 8
let runningStatus = ref(false);
let num = 0;
const ShadowMaterialyinyueRef = ref();
const moduleProvideMaterialMusicRef = ref();
const handleCallback = async (audio) => {
  if (!isChildVisible.value) {
    isChildVisible.value = true;
  }
  runningStatus.value = false;
  const musicRef = moduleProvideMaterialMusicRef.value.find(x => x.newData.message.id === audio.id)
  if (!musicRef.runningStatus) {
    ShadowMaterialyinyueRef.value.handleStop()
  } else if (musicRef.runningStatus && audio.id === bovalue.value.id) {
    ShadowMaterialyinyueRef.value.playAudio()
  }
  bovalue.value = audio;
  let res = await getPaymentRequest(audio.id);
  if (res) {
    nums(audio);
  }

};
const handleCallback1 = async (audio) => {
  // 播放状态
  if (!isChildVisible.value) {
    isChildVisible.value = true;
  }
  runningStatus.value = !runningStatus.value;
  if (!runningStatus.value) {
    ShadowMaterialyinyueRef.value.handleStop()
  } else {
    if (bovalue.value.id === audio.id) {
      ShadowMaterialyinyueRef.value.playAudio()
    }
    bovalue.value = audio;
    let res = await getPaymentRequest(audio.id);
    if (res) {
      nums(audio);
    }
  }


};
const nums = (audio) => {
  moduleProvideMaterialMusicRef.value.forEach((e) => {
    if (audio.id == e.newData.message.id) {
      e.numS1();
    }
  });
};
const pushpush = (val) => {
  router.push({
    path: "/ShadowMaterialVideoList",
    query: {
      materialType: "MUSIC",
      inputTitle: val,
    },
  });
};
const getPaymentRequest = async (materialId) => {
  return new Promise(async (resolve, reject) => {
    await Axios(
      "post",
      "/fodder/member-visited",
      {
        materialId: materialId,
      },
      false,
      (res) => {
        resolve(true);
      }
    );
  });
};
const ShadowComposerHomepage = (item) => {
  router.push({
    path: "/ShadowComposerHomepage",
    query: {
      id: item.createUser,
    },
  });
};
/* 获取当前数据接口 */
let list = ref({});
let is__ = ref(false);
const getuserMassage = function () {
  console.log(212);
  Axios("get", "/fodder/info/" + id, false, false, function (res) {
    list.value = res.data.data;
    let a = localStorage.getItem("userList") != null ? JSON.parse(localStorage.getItem("userList")).memberId : "";
    is__.value = list.value.createUser == a;
    document.title += res.data.data.title;
    // playerOptions.value.sources[0].src = res.data.data.filePath;
    likeness_other();
    getuserMassage1(list.value.createUser);
  });
};
getuserMassage();
let userList = ref([]);
let getuserMassage1 = function (id) {
  Axios("GET", "/member/info/" + id, false, false, function (res) {
    userList.value = res.data.data;
  });
};
const CertificationCenter = (item) => {
  router.push({
    path: "/AuthenTicationHome",
  });
};
/*相似类型*/
const musicLikenessList = ref([]);
const likeness_other = () => {
  const types = list.value.typeIds.split(',')
  const index = Math.floor(Math.random() * types.length)
  Axios(
    "get",
    "/fodder/front/list",
    {
      isOnline: 0,
      materialType: "MUSIC",
      paramIndex: 2, //(排序方式（0默认1最新2热门）)
      status: 1,
      pageNum: 1,
      pageSize: 8,
      materialId: id,
      typeIds: types[index]
    },
    false,
    (res) => {
      // console.log(res, '分类')
      if (res.data.rows.length == 0) {
        musicLikenessList.value = [];
      } else {
        let new_srcList = res.data.rows;
        setTimeout(() => {
          musicLikenessList.value = new_srcList;
        }, 200);
      }
    }
  );
};

//加入购物车
const shoppingTrolley = function () {
  Axios(
    "POST",
    "/fodder/car",
    {
      materialId: id,
      authType: tabListType.value,
    },
    false,
    function (res) {
      ElMessage({
        showClose: true,
        message: "已加入购物车",
        type: "success",
      });
    }
  );
};
// 搜藏
let click_sc = function () {
  // --收藏
  if (list.value.isCollect == 0) {
    Axios(
      "post",
      "/fodder/collect",
      {
        materialId: list.value.id,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已收藏",
          type: "success",
        });
        getuserMassage();
      }
    );
  } else {
    //  --取消收藏
    Axios(
      "delete",
      "/fodder/collect",
      {
        materialId: list.value.id,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已取消收藏",
          type: "warning",
        });
        getuserMassage();
      }
    );
  }
};
// 音频详情
const goParticulars = function (index) {
  console.log(index.id);
  router
    .push({
      path: "/ShadowMaterialVideoMusic",
      query: {
        id: index.id,
      },
    })
    .then(() => {
      location.reload();
    });
};
//下载

const downloadClick = function () {
  Axios(
    "GET",
    "/fodder/down",
    {
      materialId: id,
    },
    false,
    function (res) {
      router.push({
        path: "/purchasedMaterial",
      });
    },
    function (res) {
      if (res.data.code == 100) {
        Axios("get", "/fodder/order/check/" + id, {}, false, (res) => {
          router.push({
            path: "/myOrderDetial",
            query: {
              arry: id,
              authType: tabListType.value,
              totalPay: 0,
              type: "order",
            },
          });
        });
      }
    }
  );
};
onBeforeUnmount(() => {

  ShadowMaterialyinyueRef.value.isPlaying.value
    ? ShadowMaterialyinyueRef.value.handleDisplay()
    : "";
});
const collectIds = ref([])
const getCollects = async () => {
  await Axios(
    "get",
    "/fodder/collect/collect-ids",
    {
    },
    false,
    (res) => {
      collectIds.value = res.data.data
    }
  );
}
getCollects();
</script>

<style scoped>
.yinyue {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
}

.body_mlti_bottom {
  width: 0.96rem;
  position: absolute;
  top: calc(50% - 0.48rem);
  left: calc(50% - 0.48rem);
  z-index: 1;
}

.body_ml_bottom {
  overflow: hidden;
}

.body_ml_bottom>span {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #f2f3f5;
  color: #86909c;
  line-height: 0.14rem;
  font-size: 0.12rem;
  padding: 0.04rem 0.12rem;
  margin-right: 0.12rem;
  margin-top: 0.12rem;
  display: inline-block;
}

.body_ {
  width: 100%;
  background: #f2f3f5;
}

.body_main {
  width: 12.8rem;
  margin: 0 auto;
  padding: 0.3rem 0;
}

.bm_detailPage {
  width: 100%;
  background: #fff;
  padding: 0.24rem;
  border-radius: 0.08rem;
  display: flex;
  justify-content: center;
  margin-top: 0.3rem;
  margin-bottom: 0.4rem;
}

.mbd_left {
  width: 3.6rem;
  height: 3.6rem;
  position: relative;
  border-radius: 0.08rem;
  overflow: hidden;
  margin-right: 0.4rem;
}

.mbd_left_bag {
  width: 100%;
}

.mbd_left_bottom {
  /* min-width: 100%; */
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 0.25rem;
  flex: none;
}

.mbd_right {
  width: calc(100% - 3rem);
  /* flex: auto; */
  /* flex-grow: 1; */
}

.bmmt_title {
  font-size: 0.24rem;
  color: #333333;
  margin-bottom: 0.16rem;
}

.bmmt_t_list {
  display: flex;
  justify-content: left;
  align-items: center;
}

.bmmt_t_list>span {
  color: #86909c;
  font-size: 0.12rem;
  margin-right: 0.08rem;
}

.bmmt_t_list>div {
  width: 0.01rem;
  height: 0.12rem;
  background: #86909c;
  margin-right: 0.08rem;
}

.bmmt_t_click {
  display: flex;
  justify-content: left;
  margin-top: 0.24rem;
  margin-bottom: 0.16rem;
}

.bmmt_t_click>div {
  margin-right: 0.24rem;
  color: #333333;
  font-size: 0.14rem;
  display: flex;
  justify-content: left;
  align-items: center;
}

.bmmt_t_click span {
  margin-left: 0.04rem;
}

.bmmt_t_click img {
  width: 0.2rem;
}

.bmmt_t_type {
  display: flex;
  justify-content: left;
}

.bmmt_t_type>div {
  margin-right: 0.12rem;
  background: #f2f3f5;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  padding: 0.04rem 0.12rem;
}

.bmm_top {
  margin-bottom: 0.78rem;
}

.bmmb_list {
  display: flex;
  margin-bottom: 0.16rem;
}

.bmmb_list>div {
  margin-right: 0.4rem;
  padding-bottom: 0.16rem;
  font-size: 0.14rem;
}

.bmmb_listT {
  color: #c01a26;
  border-bottom: 0.02rem solid #c01a26;
}

.bmmb_listF {
  color: #333;
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0);
}

.bmmb_gn {
  display: flex;
  justify-content: space-between;
}

.bmmb_gn>div {
  display: flex;
  align-items: center;
}

.bmmbg_jg1 {
  color: #c01a26;
  font-size: 0.32rem;
  margin-right: 0.16rem;
}

.bmmbg_jg2 {
  color: #c01a26;
  background: linear-gradient(90deg, #feebd7 0%, #f8bba6 100%);
  padding: 0.04rem 0.12rem;
  font-size: 0.16rem;
  border-radius: 0.08rem;
}

.bmmbg_click1 {
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  color: #ffffff;
  font-size: 0.14rem;
  padding: 0.12rem 1.06rem;
  margin-right: 0.1rem;
  cursor: pointer;
}

.bmmbg_click2 {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  border: 0.01rem solid #c01a26;
  background: #fff;
  color: #c01a26;
  font-size: 0.14rem;
  padding: 0.12rem 0.16rem;
  cursor: pointer;
}

.bmmb_mf {
  display: inline-block;
  padding: 0.04rem 0.16rem;
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  background: #f8eee0;
  border: 0.01rem solid #fff0e4;
  font-size: 0.12rem;
  color: #5e2d11;
}

.bm_musicList {
  margin-top: 0.4rem;
}

.bm_musicList>div {
  font-size: 0.2rem;
  color: #333333;
  margin-bottom: 0.2rem;
}

.zwsj {
  width: 4rem;
  display: block;
  margin: 0 auto;
}

.module_inform {
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: saturate(21%) blur(3px);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.module_inform_body {
  width: 4.36rem;
}

.module_share_textarea {
  width: 100%;
  resize: none;
  padding: 0.12rem 0.16rem;
  color: #86909c;
  font-size: 0.14rem;
  height: 1.04rem;
  border-radius: 0.12rem;
  margin-top: 0.32rem;
  margin-bottom: 0.2rem;
}

.module_share_button {
  display: flex;
  justify-content: center;
}

.module_share_button>button {
  padding: 0.08rem 0.3rem;
  font-size: 0.14rem;

  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
}

.module_share_button_Y {
  margin-right: 0.2rem;
  border: 0.01rem solid #333333;
  color: #333;
}

.module_share_button_N {
  color: #fff;
  background: #c01a26;
  border: 0rem solid #fff;
}

.module_share_body,
.module_inform_body {
  background: #ffffff;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  padding: 0.17rem 0.24rem;
}

.module_share_body_top,
.module_share_main {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.21rem;
}

.module_share_body_top>span {
  color: #333333;
  font-size: 0.16rem;
}

.module_share_body_top>img {
  width: 0.2rem;
}

.module_share_main {
  border-bottom: 0.01rem solid #e5e6eb;
  padding-bottom: 0.2rem;
}

.module_share_main>img {
  width: 3.8rem;
  margin-right: 0.4rem;
}

.module_share_main_title {
  text-align: center;

  font-size: 0.14rem;
  color: #333333;
  line-height: 0.16rem;
}

.module_share_main_list {
  display: flex;
  justify-content: space-around;
  margin-bottom: 0.16rem;
}

.module_share_main_list>img {
  width: 0.4rem;
}

.no_data {
  width: 100%;
  height: 160px;
}

.wVC_list_l_T_B_rz {
  color: #015243;
  background: #e1fefc;
  border-radius: 0.1rem;
  font-size: 0.12rem;
  padding: 0.02rem 0.16rem 0.02rem 0.04rem;
  display: flex;
  align-items: center;
}

.wVC_list_l_T_B_rz>img {
  width: 0.23rem;
  margin-right: 0.09rem;
}
</style>
